import React, { useEffect, useState } from "react";
import { PowerBIEmbed } from "powerbi-client-react";
import * as pbi from "powerbi-client";
import { makeStyles } from "@material-ui/core/styles";
import PowerBIService from "../../services/console_services/PowerBi";
import { useParams } from "react-router-dom";

const useStyles = makeStyles(() => ({
    fullScreenContainer: {
        position: "relative",
        height: "calc(100vh - 64px)",
        width: "calc(100% - 64px)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden",
        marginLeft: '64px',
        padding:"20px"
      },
    embedContainer: {
        position: "relative",
        height: "100%",
        width: "100%",
        background:"#fff",
        borderRadius:"6px",
        boxShadow:"0 0 6px #ddd",
        overflow: "hidden",
        ['& iframe']:{
            border:"none",
            height: "100%",
            width: "100%",
          }
    },
}));

const PowerBi_Viewer = () => {
    const classes = useStyles();
    const [powerBIData, setPowerBIData] = useState(null);

    const { group, report } = useParams();

    let groupId = group || "018e90b6-62f3-4d02-a3b3-d1a160b1bc58";
    let reportId = report || "34857d93-2e02-48c1-9eb3-c6f757b4c6f4";

    useEffect(() => {
        PowerBIService.getPowerBi(groupId, reportId).then((response) => {
            if (response) {
                setPowerBIData(response);
            }
        })
            .catch((error) => console.error("Error fetching Power BI data:", error))
            .finally(() => console.log('l'));
    }, []);

    return (
        <div className={classes.fullScreenContainer}>
        <PowerBIEmbed
            embedConfig={{
                type: "report",
                id: powerBIData?.reportId,
                embedUrl: powerBIData?.embedUrl,
                accessToken: powerBIData?.embedToken,
                tokenType: pbi.models.TokenType.Embed,
                permissions: pbi.models.Permissions.All,
                viewMode: pbi.models.ViewMode.View,
                settings: {
                    panes: {
                        filters: {
                            expanded: true,
                            visible: true,
                        },
                    },
                    background: pbi.models.BackgroundType.Transparent,
                },
            }}
            cssClassName={classes.embedContainer}
            getEmbeddedComponent={(embeddedReport) => {
                window.report = embeddedReport;
            }}
        />
        </div>
    );
};

export default PowerBi_Viewer;
